import { render, staticRenderFns } from "./ActionFeedbackDisplay.vue?vue&type=template&id=2f83997d&scoped=true&"
import script from "./ActionFeedbackDisplay.vue?vue&type=script&lang=ts&"
export * from "./ActionFeedbackDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./ActionFeedbackDisplay.vue?vue&type=style&index=0&id=2f83997d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f83997d",
  null
  
)

export default component.exports